module.exports = __webpack_public_path__ + "static/img/index_btn_3.35d08ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_btn_3.png
// module id = bCHs
// module chunks = 1